// ScholarshipsDiscountsViewController.tsx
import React, { useEffect, useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ScholarshipsDiscountsView from './ScholarshipsDiscountsView';
import routes from '@/presentation/components/Routes/routingMap';
import IconBse from '@/assets/icons/bse-discounts/icon-bse.svg';
import IconIntercorp from '@/assets/icons/bse-discounts/icon-intercorp.svg';
import { Creators as scholarshipsDiscountsActions } from '@/domain/useCases/scholarshipsDiscounts/getScholarshipsDiscounts/actions';

const ScholarshipsDiscountsViewController: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading, error, data } = useSelector(
    (state: any) => state.getScholarshipsDiscounts
  );

  useEffect(() => {
    dispatch(scholarshipsDiscountsActions.getScholarshipsDiscounts());
  }, [dispatch]);

  const scholarships = useMemo(() => {
    if (!data) return [];
    return [
      data.bse && {
        id: data.bse.id,
        name: 'Beca Socioeconómica',
        logoUrl: IconBse,
        discountText: `${data.bse.percentage} de descuento`,
        redirectUrl: routes.student.procedures.categories.scholarships.bse.home,
        isNew:
          data.bse.date !== undefined && new Date() < new Date(data.bse.date),
        isDisabled: data.bse.isDisabled
      },
      data.intercorp && {
        id: data.intercorp.id,
        name: 'Convenio de Grupo Intercorp',
        logoUrl: IconIntercorp,
        discountText: `${data.intercorp.percentage} de descuento`,
        redirectUrl: '/tramites/becas-descuentos/intercorp',
        isNew:
          data.intercorp.date !== undefined &&
          new Date() < new Date(data.intercorp.date),
        isDisabled: data.intercorp.isDisabled
      }
    ].filter(Boolean) as Array<{
      id: string;
      name: string;
      logoUrl: string;
      discountText: string;
      redirectUrl: string;
      isNew: boolean;
      isDisabled: boolean;
    }>;
  }, [data]);

  const handleBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const handlerRedirectNewPage = useCallback(
    (url: string) => {
      history.push(url);
    },
    [history]
  );

  return (
    <ScholarshipsDiscountsView
      isLoading={isLoading}
      scholarships={scholarships}
      handlerRedirectNewPage={handlerRedirectNewPage}
      handleBack={handleBack}
      error={error}
    />
  );
};

export default ScholarshipsDiscountsViewController;
